/**
 * 得到一个两数之间的随机整数
 * @description 返回在指定值之间的随机整数。
 * @description 这个值不小于 min （如果 min 不是整数，则不小于 min 的向上取整数），且小于（不等于）max。
 */
export function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  // 不含最大值，含最小值
  return Math.floor(Math.random() * (max - min)) + min;
}

/**
 * 得到一个两数之间的随机整数，包括最大值最小值在内
 * @param min
 * @param max
 * @returns
 */
export function getRandomIntInclusive(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateUUID() {
  let d = new Date().getTime();
  const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x7) | 0x8).toString(16);
  });
  return uuid;
}
